export const NEWS_DETAIL_BASE_CLASS = 'mt-NewsDetail'
export const NEWS_DETAIL_EXTRA_INFO_BASE_CLASS = `${NEWS_DETAIL_BASE_CLASS}-extraInfo`
export const NEWS_DETAIL_LATEST_PLATES_WRAPPER_BASE_CLASS = `${NEWS_DETAIL_BASE_CLASS}-latestPlatesWrapper`
export const DEFAULT_COMMENTS_COUNT = 10
export const DEFAULT_COMMENTS_OFFSET = 1
